<template>
  <div class="z-10 flex items-center justify-between">
    <CommonButton
      data-testid="video-card-button"
      class="self-start py-3"
      :variant="variantButton"
      skip-width-classes
      @click="$emit('play')"
    >
      <div
        class="m-0 flex w-full flex-row items-center justify-between gap-x-1 p-0"
      >
        <IconOutlinePlayCircle
          v-if="isAuthorized || hasPreview"
          class="h-5 w-5 text-xl"
        />
        <span class="w-max text-sm font-semibold">
          {{ textButton }}
        </span>
      </div>
    </CommonButton>
    <CheckSubscriptionIcon
      v-if="isAuthorized"
      class="h-8 w-8 text-p-900"
      data-testid="video-card-item-check"
    />
    <CloseLockIcon
      v-else
      class="h-8 w-8 text-p-900"
      data-testid="video-card-item-lock"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CommonButton from '~/components/common/Button.vue'
import IconOutlinePlayCircle from '~/assets/icons/outline-play-circle.svg'
import CheckSubscriptionIcon from '~/assets/icons/check-subscribe.svg'
import CloseLockIcon from '~/assets/icons/LockOutline.svg'

const props = withDefaults(
  defineProps<{
    isAuthorized: boolean
    hasPreview?: boolean
    textButton?: string
  }>(),
  {
    hasPreview: false,
    textButton: 'Contact Us',
  },
)

const variantButton = computed(() => {
  return props.hasPreview || props.isAuthorized ? 'primary' : 'clean'
})
</script>
